import React, {useEffect, useState} from "react";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import {
    Avatar,
    Box, Button, Checkbox, CircularProgress,
    Dialog, DialogActions,
    DialogContent,
    DialogTitle, FormControlLabel, Grid, Radio, RadioGroup, TextField,
    Typography, useMediaQuery, Snackbar
} from "@material-ui/core";
import {useSnackbar} from "notistack";
import moment from "moment";
import Image from "material-ui-image";
import {BirdIconSVG, ChickenIconSVG, PetCatSVG, PetDogSVG} from "../../../utils/petTypeIcons";
import {ReactComponent as LogoSVG} from "../../../Images/logo.svg";
import API from "../../../helpers/apiHelpers";
import {api_editAnimal} from "../../../redux/pets/pets.api";
import {WEEK_DAYS} from "../../../Constants/week_days";
import {
    getAppointmentNoteByID,
    getPrescriptions,
    getFollowUpByID,
    patchFollowUps,
    postFollowUps, patchAppointmentNotes
} from "../../../redux/appointment/appointment.actions";
import {RootState, useAppDispatch} from "../../../redux/store";
import {setPetAgeShort, setPetType} from "../../../utils/petInfo";
import {useSelector} from "react-redux";
import MuiPhoneNumber from "material-ui-phone-number";
import DocCard from "../../../Components/DocCard";
import {jsPDF} from "jspdf";
import Logo from "../../../Images/logoNew.png";
import {visitOutcomes} from "../../../Constants/visitOutcomes";
import {reasonsForVisit, reasonForVisitAtlanta} from "../../../Constants/reasonsForVisit";
import {colorInputBorder} from "../../../Constants/theme";
import {backgroundColor} from "html2canvas/dist/types/css/property-descriptors/background-color";

const useStyles = makeStyles((theme) => ({
    dialog: {
        padding: "48px 0 48px 25px",
        maxWidth: "1600px"
    },
    container: {
        marginTop: "10px"
    },
    button: {
        margin: "1.5em 1.5em 0 0",
        padding: "13px 28px",
    },
    iconBox: {
        width: 16,
        height: 16,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: 14,
    },
    buttonContainer: {
        marginTop: 30,
        marginBottom: 20,
        [theme.breakpoints.down("sm")]: {
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
        },
    },
    textPlain: {
        fontSize: 18,
        whiteSpace: "nowrap",
    },
    preStyle: {
        overflowX: "auto",
        whiteSpace: "pre-wrap",
        wordWrap: "break-word",
        fontFamily: "inherit",
        margin: 0
    },
    actions: {
        paddingLeft: "24px"
    },
    medicationField: {
        fontSize: 18,
        marginBottom: "15px"
    },
    petCard: {
        boxShadow: "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
        padding: "10px 0 10px 0",
        margin: "20px 0 20px 0"
    },
    snackbarStyleViaContentProps: {
        backgroundColor: "green"
    },
}));

const medicationsFields = {
    name: "Name of Medication",
    quantity: "Quantity/Size",
    refills: "Refills",
    strength: "Medication Strength",
    fillingOption: "Filling Options"
};

// eslint-disable-next-line react/prop-types
const MedicalRecordsModal = ({isOpen, setOpenDialog, noteId = null}) => {
    const {enqueueSnackbar} = useSnackbar();
    const classes = useStyles();
    const theme = useTheme();
    const dispatch = useAppDispatch();
    const [open, setOpen] = useState(false);
    const [openSnack, setOpenSnack] = useState(false)
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const isSm = useMediaQuery(theme.breakpoints.down("sm"));
    const [loaderShowed, setLoaderShowed] = useState(false);
    const [contentType, setContentType] = useState("notes");
    const [animal, setAnimal] = useState<undefined | any>();
    const [appointmentInfo, setAppointmentInfo] = useState<undefined | any>();
    const [notes, setNotes] = useState<undefined | any>();
    const [medications, setMedications] = useState([]);
    const [vet, setVet] = useState<undefined | any>();
    const [vetImage, setVetImage] = useState<undefined | string>();
    const [comment, setComment] = useState("");
    const [rxOTCAdministered, setRxOTCAdministered] = useState(false);
    const user: undefined | any = useSelector((state: RootState) => state?.user);
    const handleClose = () => {
        setOpenDialog(false);
        setNotes(null);
        setFollow(null);
        setIsFollow(false);
    };
    const contactUsDefault = appointmentInfo?.animal?.primaryVetName?.length
        ? "Our normal business hours are 9am - midnight ET. If your pet has a medical emergency after hours, please seek care immediately at the closest veterinary emergency hospital."
        : "Our normal business hours are 9am - midnight EST. If your pet has a medical emergency after hours, and you cannot reach The Video Vet's support team at one of the contact methods below, please seek care immediately at the closest veterinary emergency hospital. If you have questions or concerns or need to schedule any follow-up appointments with a The Video Vets veterinarian please contact us. You can also schedule appointments directly via The Video Vets App or on the Web.\n\n*The Video Vets Contact Information*\n-Email: hello@thevideovets.com\n-Website: thevideovets.com (click the chat box in the lower right hand corner)";
    //IC COPY
    const [consentForm, setConsentForm] = useState<null | any>(null);
    const [receipt, setReceipt] = useState<any>();
    const [logoB64, setLogoB64] = useState("");
    const [handout, setHandout] = useState(null);
    const [follow, setFollow] = useState(null);
    const [isFollow, setIsFollow] = useState(false);

    const formatDate = (date) => {
        const tz = moment.tz.guess();
        const time = moment.tz(date, tz);
        const dayOfWeek = WEEK_DAYS[moment(time).day()];
        const dayOfWeekFormatted = dayOfWeek.charAt(0) + dayOfWeek.slice(1).toLowerCase();
        return `${dayOfWeekFormatted}, ${time.format("MMMM D")} at ${time.format("h:mma")}`;
    };
    const handleClickSnack = () => {
        setOpenSnack(true);
    };

    const handleCloseSnack = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setOpenSnack(false);
    };
    useEffect(() => {
        (async () => {
            if (contentType === "followup") {
                try {
                    const followUp = await dispatch(getFollowUpByID(appointmentInfo.id));
                    if (followUp[0]) {
                        setIsFollow(true);
                        setFollow(followUp[0]);
                    }
                } finally {
                    setLoaderShowed(false);
                }
            }})();
    },[contentType]);

    useEffect(() => {
        setOpenDialog(isOpen);
        (async () => {
            if (isOpen && noteId) {
                try {
                    setLoaderShowed(true);
                    const note = await dispatch(getAppointmentNoteByID(noteId));
                    const {appointment} = note;
                    const {animal, vetUserId} = appointment;
                    const vets = appointment.type !== "RHAPSODY" && await API.getProfiles({userId: vetUserId});
                    setNotes(note);
                    setComment(note.comments);
                    setVet(vets[0]);
                    setVetImage(vets[0]?.image);
                    setAppointmentInfo(appointment);
                    setAnimal(animal);
                    const medications = await dispatch(getPrescriptions(appointment.id));
                    setMedications(medications);
                    setRxOTCAdministered(!!medications.length);
                    setContentType((note?.comments && user.role !== "OWNER") ? "comments" : "notes");
                    setHandout(note?.handouts[0]);
                    API.getConsentForm(appointment.id).then(res => Object.prototype.hasOwnProperty.call(res, "imageUrl") ? setConsentForm(res.imageUrl) : console.log("consent form not found", res));
                } catch (err) {
                    //
                } finally {
                    setLoaderShowed(false);
                }
            }
        })();
    }, [isOpen, noteId]);
    const handlePharmacyInfo = () => {
        api_editAnimal(animal.id, animal).then(async () => {
            await dispatch(patchAppointmentNotes(noteId, {
                comments: comment
            }));
            handleClickSnack();
        });

    };

    const handleFollowUpdate = () => {
        if (
            typeof (follow?.appealAfterAppointment) === "boolean" &&
            follow?.animalFeeling &&
            follow?.completedBy?.length) {
            if (follow?.animalFeeling === "OTHER" && !follow?.otherAnimalFeelingComment?.length) {
                enqueueSnackbar("Provide information for type \"Other\"", {
                    variant: "error",
                    autoHideDuration: 3000,
                });
                return;
            }
            if (isFollow) {
                dispatch(patchFollowUps(follow, follow.id))
                    .then(() => handleClickSnack());
            } else {
                const body = {
                    ...follow,
                    appointmentId: appointmentInfo.id,
                    visitOutcome: notes.visitOutcome,
                };
                dispatch(postFollowUps(body))
                    .then(() =>
                    {
                        handleClickSnack();
                        handleClose();
                    });
            }
        }
        else enqueueSnackbar("Fill in all the fields!", {
            variant: "error",
            autoHideDuration: 3000,
        });
    };
    const isDisable = () => {
        if (follow?.animalFeeling === "OTHER")
            return !(typeof (follow?.appealAfterAppointment) === "boolean" &&
                follow?.completedBy?.length &&
                follow?.animalFeeling === "OTHER" && follow?.otherAnimalFeelingComment?.length);
        else
            return !(typeof (follow?.appealAfterAppointment) === "boolean" &&
                follow?.animalFeeling &&
                follow?.completedBy?.length);
    };
    const convertBase64 = async (img) => {
        // blob to dataURL
        function blobToDataURL(blob, callback) {
            var a = new FileReader();
            a.onload = function (e) {
                callback(e.target.result);
            };
            a.readAsDataURL(blob);
        }

        const file = await fetch(img).then(res => res.blob());

        blobToDataURL(file, function (dataurl) {
            setLogoB64(dataurl);
        });

    };

    useEffect(() => {
        if (appointmentInfo) {
            (async () => {
                if (!appointmentInfo.pending && appointmentInfo.status === "ACCEPTED") {
                    const data = await API.getAppointmentReciept(appointmentInfo.id);
                    if (!Object.prototype.hasOwnProperty.call(data, "message")) {
                        await convertBase64(Logo);
                        setReceipt(data);
                    }
                }
            })();
        }
    }, [appointmentInfo]);

    const handleReceipt = () => {
        const doc = new jsPDF();
        doc.addImage(logoB64, 10, 7, 20, 20, "logo", "NONE", 0);
        doc.setFontSize(12);
        doc.text("Contact Us", 100, 10, {align: "center"});
        doc.text("hello@thevideovets.com", 100, 17, {align: "center"});
        doc.text("1621 Central Ave.", 180, 17, {align: "center"});
        doc.text("Cheyenne, WY 82001", 180, 24, {align: "center"});
        doc.setFontSize(16);
        doc.text("Appointment Receipt", 10, 50);
        doc.setFontSize(12);
        doc.text("Appointment ID", 15, 60);
        doc.text("Client", 15, 67);
        doc.text("Pet", 110, 74);
        doc.text("Date", 110, 60);
        doc.text("Time", 110, 67);
        doc.text("Veterinarian", 15, 74);
        //change color:
        doc.setTextColor(138, 138, 138);
        doc.text(receipt.appointmentId.toString(), 50, 60);
        doc.text(`${receipt.clientFirstName} ${receipt.clientLastName}`, 50, 67);
        doc.text(receipt.vetName, 50, 74);
        doc.text(receipt.appointmentDate, 130, 60);
        doc.text(moment(receipt.time).format("LT"), 130, 67);
        doc.text(receipt.petName, 130, 74);
        //HR
        doc.setTextColor(0);
        doc.line(10, 87, 200, 87);
        //Line Items:
        doc.setFontSize(16);
        doc.text("Description", 15, 97);
        doc.text("Amount", 140, 97);
        doc.setFontSize(12);
        doc.text("Appointment Fee", 15, 107);
        doc.setTextColor(138, 138, 138);
        doc.text(receipt.paidPrice, 140, 107);
        //Payment lines:
        doc.setTextColor(0);
        doc.text("Total", 120, 127);
        doc.text("Payment Method", 97.5, 137);
        doc.setTextColor(138, 138, 138);
        doc.text(receipt.paidTotalAmount, 140, 127);
        doc.text(`${receipt.cardType} ****${receipt.cardLastFourDigits}`, 140, 137);
        //Footer
        doc.setFontSize(10);
        doc.text("Thank you for choosing The Video Vets!", 100, 155, {align: "center"});
        doc.save(`${animal["name"]}_${appointmentInfo.id}.pdf`);
    };

    const getReasonsForVisit = (reasonForVisit?: string[]): string => {
        if (appointmentInfo.animal.primaryVetName === "East Atlanta Animal Clinic") return reasonForVisitAtlanta[0].type;
        return reasonForVisit.map((reason) => reasonsForVisit
            .find(({value}) => value === reason).type)
            .join(", ");
    };

    const downloadRecord = () => {
        const doc = new jsPDF();
        let height = doc.internal.pageSize.getHeight();
        let currHeight = 105;

        const generateRowHeight = (marginL, x) => {
            return (title, prevHeight, text) => {
                let formatted;
                let formattedDim;
                let newHeight;
                currHeight += x;
                if (text && text !== "undefined") {
                    formatted = doc.splitTextToSize(text, 110);
                } else {
                    formatted = doc.splitTextToSize("—", 110);
                }
                formattedDim = doc.getTextDimensions(formatted);
                newHeight = prevHeight + formattedDim.h;
                doc.setTextColor(119, 119, 119);

                if (newHeight > height - 10) {
                    doc.addPage();
                    doc.text(formatted, 90, 10);
                    doc.setTextColor(39, 56, 120);
                    doc.text(title, 20 + marginL, 10);
                    currHeight = 10 + formattedDim.h;
                } else {
                    doc.text(formatted, 90, currHeight);
                    doc.setTextColor(39, 56, 120);
                    doc.text(title, 20 + marginL, currHeight);
                    currHeight = newHeight + x;
                }
            };
        };

        const generateMedicationsHeight = generateRowHeight(10, 6);
        const generateHeight = generateRowHeight(0, 15);

        doc.addImage(logoB64, 10, 7, 20, 20, "logo", "NONE", 0);
        doc.setFontSize(12).setTextColor(39, 56, 120).setFont("NotoSerifDisplay", "bold");
        doc.text("Support", 100, 10, {align: "center"});
        doc.text("hello@thevideovets.com", 100, 17, {align: "center"});
        doc.text("1621 Central Ave.", 180, 10, {align: "center"});
        doc.text("Cheyenne, WY 82001", 180, 17, {align: "center"});

        doc.setFontSize(16).setTextColor(39, 56, 120).setFont("NotoSerifDisplay", "bold");
        doc.text("Appointment Details", 10, 50);
        doc.setFontSize(12).text("Date", 20, 65);
        doc.text("Pet", 110, 65);
        doc.text("Client", 20, 80);
        doc.text("Veterinarian", 110, 80);

        doc.setTextColor(119, 119, 119);
        doc.text(receipt.appointmentDate, 50, 65);
        doc.text(receipt.petName, 140, 65);
        doc.text(`${receipt.clientFirstName} ${receipt.clientLastName}`, 50, 80);
        doc.text(receipt.vetName, 140, 80);
        doc.setTextColor(0);
        doc.line(10, 90, 200, 90);

        doc.setFontSize(16).setTextColor(39, 56, 120).setFont("NotoSerifDisplay", "bold");
        doc.text("Appointment Notes", 10, 105);

        doc.setFontSize(12);
        generateHeight("Reason for visit", currHeight, getReasonsForVisit(notes.reasonForVisit));
        generateHeight("Owner Concerns", currHeight, notes.assessment);
        generateHeight("Subjective", currHeight, notes.subjective);
        generateHeight("Objective", currHeight, notes.objective);
        generateHeight("Assessment ", currHeight, notes.assessment);
        generateHeight("Plan", currHeight, notes.plan);
        generateHeight("Prescriptions & OTC", currHeight, rxOTCAdministered ? "Yes" : "No");

        if (rxOTCAdministered) {
            medications.forEach((item, i) => {
                Object.entries(item)
                    .filter(([key]) => medicationsFields[key])
                    .forEach(([key, value]: any, j) => {
                        doc.setTextColor(119, 119, 119);
                        if (key === "fillingOption") {
                            generateMedicationsHeight(medicationsFields[key], currHeight, value === "RALPHIE_PHARMACY" ? "The Video Vets pharmacy" : "Call In");
                        } else {
                            generateMedicationsHeight(medicationsFields[key], currHeight, value);
                        }
                    }
                    );
            });
        }
        generateHeight("Outcome", currHeight, `${visitOutcomes.find(({value}) => value === notes.visitOutcome)?.label}`);
        doc.save(`${animal["name"]}_record_${appointmentInfo.id}.pdf`);
    };

    const contentSwitch = user.role !== "OWNER" ?
        [
            {label: "Appointment Notes", value: "notes"},
            {label: "Follow Up", value: "followup"},
            {label: "Comments", value: "comments"},
        ] :
        [
            {label: "Appointment Notes", value: "notes"},
            {label: "Comments", value: "comments"},
        ];
    const options = [
        {value: "GREAT", label: "Great"},
        {value: "IMPROVING", label: "Improving"},
        {value: "ABOUT_THE_SAME", label: "About the same"},
        {value: "GETTING_WORSE", label: "Getting worse"},
        {value: "OTHER", label: "Other"},
    ];

    return (
        <Dialog
            open={isOpen}
            onClose={handleClose}
            classes={{paper: classes.dialog}}
            scroll="body"
            disableEnforceFocus
        >
            <DialogTitle color="primary">
                <Typography variant="h3">
                    Medical Record Details
                </Typography>
            </DialogTitle>
            <DialogContent>
                {loaderShowed ?
                    <Box display="flex" justifyContent="center" alignItems="center" height="200px">
                        <CircularProgress/>
                    </Box>
                    : notes ?
                        <Grid container justify="space-between">
                            <Grid item xs={12} sm={12} md={4}>
                                <Grid item xs={12} sm={12} md={10}>
                                    <DocCard
                                        docType={vet?.type}
                                        docFirstName={vet?.firstName}
                                        docLastName={vet?.lastName}
                                        docEdu={vet?.education}
                                        docImage={vetImage}
                                        setDocImage={setVetImage}
                                        scheduledDate={appointmentInfo?.scheduledDate}
                                        appointmentType={appointmentInfo?.type}
                                        animalName={animal.name}
                                        dateOfBirth={animal.dateOfBirth}
                                    />
                                </Grid>
                                <Grid item container xs={12} sm={12} md={10}>
                                    <Grid item container xs={12} alignItems="center" className={classes.petCard}
                                        spacing={1}>
                                        <Grid item xs={5} sm={3} justify="flex-start">
                                            <Avatar variant="square"
                                                style={{width: "100%", height: "auto", borderRadius: 5}}>
                                                {
                                                    animal?.imageUrl ? {
                                                        "FELINE": <Image alt="image of a cat" src={animal?.imageUrl} errorIcon={<PetCatSVG/>}
                                                            imageStyle={{objectFit: "cover"}}
                                                            style={{width: "100%"}}/>,
                                                        "CANINE": <Image alt="image of a dog" src={animal?.imageUrl} errorIcon={<PetDogSVG/>}
                                                            imageStyle={{objectFit: "cover"}}
                                                            style={{width: "100%"}}/>,
                                                        "AVIAN": <Image alt="image of a bird" src={animal?.imageUrl} errorIcon={<BirdIconSVG/>}
                                                            imageStyle={{objectFit: "cover"}}
                                                            style={{width: "100%"}}/>,
                                                        "CHICKEN": <Image alt="image of a chicken" src={animal?.imageUrl} errorIcon={<ChickenIconSVG/>}
                                                            imageStyle={{objectFit: "cover"}}
                                                            style={{width: "100%"}}/>,
                                                        "Other":
                                                                <Box display="flex" justifyContent="center"
                                                                    alignItems="center" width="100px" height="100px">
                                                                    {
                                                                        animal?.imageUrl &&
                                                                        <Image alt="pet image" imageStyle={{objectFit: "cover"}}
                                                                            src={animal?.imageUrl} errorIcon={<LogoSVG/>}
                                                                            style={{width: "100%"}}/>
                                                                    }
                                                                </Box>
                                                    }[setPetType(animal?.type)] :
                                                        {
                                                            "FELINE": <PetCatSVG
                                                                style={{width: "100%", objectFit: "cover"}}/>,
                                                            "CANINE": <PetDogSVG
                                                                style={{width: "100%", objectFit: "cover"}}/>,
                                                            "AVIAN": <BirdIconSVG
                                                                style={{width: "100%", objectFit: "cover"}}/>,
                                                            "CHICKEN": <ChickenIconSVG
                                                                style={{width: "100%", objectFit: "cover"}}/>,
                                                            "Other":
                                                                <Box display="flex" justifyContent="center"
                                                                    alignItems="center" width="100px" height="100px">
                                                                    <LogoSVG
                                                                        style={{width: "100%", objectFit: "cover"}}/>
                                                                </Box>
                                                        }[setPetType(animal?.type)]
                                                }
                                            </Avatar>
                                        </Grid>
                                        <Grid item xs={7} sm={9} alignItems="center">
                                            <Typography variant="h4"
                                                className={classes.textPlain} style={{wordBreak: "break-all", whiteSpace: "normal"}}>{animal?.name}</Typography>
                                            <Typography color="textSecondary">
                                                {animal?.breed ? `${animal?.breed} - ` : null}
                                                {setPetAgeShort(animal?.dateOfBirth)}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container direction="row" justify="flex-start" spacing={1}>
                                        {user.role !== "VET" &&
                                        <>
                                            {receipt
                                            &&
                                            <Grid item xs={12}>
                                                <Button type="button" onClick={() => handleReceipt()}
                                                    variant="contained"
                                                    fullWidth
                                                >
                                                    Receipt
                                                </Button>
                                            </Grid>}
                                            {
                                                (notes && receipt)
                                                &&
                                                <Grid item xs={12}>
                                                    <Button
                                                        type="button"
                                                        onClick={() => downloadRecord()}
                                                        variant="contained"
                                                        fullWidth
                                                    >
                                                        Download Record
                                                    </Button>
                                                </Grid>

                                            }
                                        </>
                                        }

                                        {consentForm &&
                                        <Grid item xs={12}>
                                            <Button
                                                type="button"
                                                onClick={() => window.open(consentForm, "_blank")}
                                                variant="contained"
                                                fullWidth
                                                style={{lineHeight: "16px"}}
                                            >
                                                Informed Consent Form
                                            </Button>
                                        </Grid>
                                        }
                                        {handout &&
                                        <Grid item xs={12}>
                                            <Button
                                                type="button"
                                                variant="contained"
                                                fullWidth
                                            >
                                                <a style={{textDecoration: "none", cursor: "pointer"}}
                                                    href={handout?.path}>
                                                    <Typography variant="h4" style={{color: colorInputBorder, fontSize: 16}}>
                                                        Download Handout
                                                    </Typography>
                                                </a>
                                            </Button>
                                        </Grid>
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8}>
                                <Grid container>
                                    <Grid container spacing={1} xs={12}
                                        style={{marginBottom: "20px", marginTop: `${isSm ? "10px" : "0"}`}}>
                                        {contentSwitch.map((item, idx) => {
                                            if (item.value === contentType) {
                                                return (
                                                    <Grid key={idx} item xs={12} md={4}>
                                                        <Button
                                                            type="button"
                                                            onClick={() => {
                                                                setContentType.bind(null, item.value);
                                                            }}
                                                            color="secondary"
                                                            variant="contained"
                                                            fullWidth
                                                        >{item.label}
                                                        </Button>
                                                    </Grid>);
                                            }
                                            return (<Grid key={idx} item xs={12} md={4}>
                                                <Button
                                                    type="button"
                                                    onClick={setContentType.bind(null, item.value)}
                                                    variant="contained"
                                                    fullWidth
                                                >
                                                    {item.label}
                                                </Button>
                                            </Grid>);
                                        })}
                                    </Grid>
                                    {contentType === "comments" ?
                                        <>
                                            <Snackbar
                                                open={openSnack}
                                                autoHideDuration={2000}
                                                onClose={handleCloseSnack}
                                                message="Success!"
                                                anchorOrigin={{
                                                    vertical: "top",
                                                    horizontal: "center"
                                                }}
                                                //@ts-ignore
                                                ContentProps={{
                                                    className: classes.snackbarStyleViaContentProps
                                                }}
                                            />
                                            <Grid item xs={12}>
                                                <Box marginBottom="15px">
                                                    <Typography variant="h4" className={classes.textPlain}>
                                                        Appointment Comments
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Box marginBottom="20px">
                                                    <TextField
                                                        multiline
                                                        fullWidth
                                                        value={comment}
                                                        placeholder={"No comments"}
                                                        onChange={(event) => setComment(event.target.value)}
                                                        variant="outlined"
                                                        disabled={user.role !== "ADMIN"}
                                                    />
                                                </Box>
                                            </Grid>
                                            {user.role === "ADMIN" &&
                                                <>
                                                    <Grid item xs={12}>
                                                        <Box marginBottom="15px">
                                                            <Typography variant="h4" className={classes.textPlain}>
                                                                Pharmacy Name
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Box marginBottom="20px">
                                                            <TextField
                                                                multiline
                                                                fullWidth
                                                                value={animal?.pharmacyName || ""}
                                                                variant="outlined"
                                                                onChange={(event) => setAnimal({...animal, pharmacyName: event.target.value})}
                                                            />
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Box marginBottom="15px">
                                                            <Typography variant="h4" className={classes.textPlain}>
                                                                Pharmacy Phone Number
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Box marginBottom="20px">
                                                            <MuiPhoneNumber
                                                                id="phoneNumber"
                                                                name="phoneNumber"
                                                                defaultCountry={"us"}
                                                                onlyCountries={["us"]}
                                                                onChange={(value) => setAnimal({...animal, pharmacyPhone: value})}
                                                                value={animal?.pharmacyPhone}
                                                                disableCountryCode={true}
                                                                variant="outlined"
                                                                fullWidth
                                                            />
                                                        </Box>
                                                    </Grid>
                                                    <Button
                                                        type="button"
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={handlePharmacyInfo}
                                                        className={classes.button}
                                                    >
                                                        Save
                                                    </Button>
                                                </>
                                            }
                                        </> :
                                        contentType === "notes" ?
                                            <>
                                                <Grid item xs={12}>
                                                    <Box marginBottom="15px">
                                                        <Typography variant="h4" className={classes.textPlain}>
                                                            Reason For Visit
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Box marginBottom="20px">
                                                        <TextField
                                                            multiline
                                                            fullWidth
                                                            value={getReasonsForVisit(notes?.reasonForVisit)}
                                                            variant="outlined"
                                                            disabled
                                                        />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Box marginBottom="15px">
                                                        <Typography variant="h4" className={classes.textPlain}>
                                                            Owner Concerns
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Box marginBottom="20px">
                                                        <TextField
                                                            multiline
                                                            fullWidth
                                                            value={notes?.ownerConcerns}
                                                            variant="outlined"
                                                            disabled
                                                        />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Box marginBottom="15px">
                                                        <Typography variant="h4" className={classes.textPlain}>
                                                            Subjective
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Box marginBottom="20px">
                                                        <TextField
                                                            multiline
                                                            fullWidth
                                                            value={notes?.subjective}
                                                            variant="outlined"
                                                            disabled
                                                        />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Box marginBottom="15px">
                                                        <Typography variant="h4" className={classes.textPlain}>
                                                            Objective
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Box marginBottom="20px">
                                                        <TextField
                                                            multiline
                                                            fullWidth
                                                            value={notes?.objective}
                                                            variant="outlined"
                                                            disabled
                                                        />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Box marginBottom="15px">
                                                        <Typography variant="h4" className={classes.textPlain}>
                                                            Assessment
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Box marginBottom="20px">
                                                        <TextField
                                                            multiline
                                                            fullWidth
                                                            value={notes?.assessment}
                                                            variant="outlined"
                                                            disabled
                                                        />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Box marginBottom="15px">
                                                        <Typography variant="h4" className={classes.textPlain}>
                                                            Plan
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Box marginBottom="20px">
                                                        <TextField
                                                            multiline
                                                            fullWidth
                                                            value={notes?.plan}
                                                            variant="outlined"
                                                            disabled
                                                        />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Box marginBottom="15px">
                                                        <Typography variant="h4" className={classes.textPlain}>
                                                            Contact Information
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Box marginBottom="20px">
                                                        <TextField
                                                            multiline
                                                            fullWidth
                                                            value={notes?.contactUsInfo ? notes.contactUsInfo : contactUsDefault}
                                                            variant="outlined"
                                                            disabled
                                                        />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Box display="flex" alignItems="center" marginBottom="15px">
                                                        <Box marginRight="30px">
                                                            <Typography variant="h4" className={classes.textPlain}>
                                                                Rx/OTC Administered?
                                                            </Typography>
                                                        </Box>
                                                        <RadioGroup row>
                                                            <FormControlLabel
                                                                control={<Radio/>}
                                                                color="secondary"
                                                                checked={rxOTCAdministered}
                                                                label={<Typography color="textSecondary">Yes</Typography>}
                                                            />
                                                            <FormControlLabel
                                                                control={<Radio/>}
                                                                color="secondary"
                                                                checked={!rxOTCAdministered}
                                                                label={<Typography color="textSecondary">No</Typography>}
                                                            />
                                                        </RadioGroup>
                                                    </Box>
                                                </Grid>
                                                {rxOTCAdministered &&
                                                <Grid item xs={12}>
                                                    <Box marginBottom="15px">
                                                        <Typography variant="h4" className={classes.textPlain}>
                                                            Medication Details:
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                }
                                                {medications.map(item => (
                                                    <>
                                                        <Grid item xs={12} container>
                                                            <Grid item sm={6} xs={12}>
                                                                <Typography variant="h4"
                                                                    className={classes.medicationField}>
                                                                    Name of Medication
                                                                </Typography>
                                                                <Typography color="textSecondary"
                                                                    className={classes.medicationField}>
                                                                    {item?.name}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item sm={6} xs={12}>
                                                                <Typography variant="h4"
                                                                    className={classes.medicationField}>
                                                                    Medication Strength
                                                                </Typography>
                                                                <Typography color="textSecondary"
                                                                    className={classes.medicationField}>
                                                                    {item?.strength}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item sm={6} xs={12}>
                                                                <Typography variant="h4"
                                                                    className={classes.medicationField}>
                                                                    Quantity/Size
                                                                </Typography>
                                                                <Typography color="textSecondary"
                                                                    className={classes.medicationField}>
                                                                    {item?.quantity}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item sm={6} xs={12}>
                                                                <Typography variant="h4"
                                                                    className={classes.medicationField}>
                                                                    Refills
                                                                </Typography>
                                                                <Typography color="textSecondary"
                                                                    className={classes.medicationField}>
                                                                    {item?.refills}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item sm={6} xs={12}>
                                                                <Typography variant="h4"
                                                                    className={classes.medicationField}>
                                                                    Filling Options
                                                                </Typography>
                                                                <Typography color="textSecondary"
                                                                    className={classes.medicationField}>
                                                                    {item?.fillingOption === "RALPHIE_PHARMACY" ? "The Video Vets pharmacy" : "Call In"}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Box marginTop="10px" marginBottom="15px">
                                                                <Typography variant="h4" className={classes.textPlain}>
                                                                    Rx/OTC Label Instructions
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Box marginBottom="20px" style={{maxWidth: 550}}>
                                                                <Typography color="textSecondary"
                                                                    className={classes.textPlain}>
                                                                    {item?.labelInstructions}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>

                                                    </>
                                                ))
                                                }
                                                <Grid item xs={12}>
                                                    <Box marginBottom="15px">
                                                        <Typography variant="h4" className={classes.textPlain}>
                                                            Outcome
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Box marginBottom="20px">
                                                        <TextField
                                                            multiline
                                                            fullWidth
                                                            value={visitOutcomes.find(({value}) => value === notes?.visitOutcome)?.label}
                                                            variant="outlined"
                                                            disabled
                                                        />
                                                    </Box>
                                                </Grid>
                                                {notes.appointment.imageUrl?.length
                                            &&
                                            <Grid item xs={12}>
                                                <Box marginBottom="20px">
                                                    <Box display="flex" alignItems="center" marginBottom="15px"
                                                        flexWrap="wrap">
                                                        <Box marginRight="30px">
                                                            <Typography variant="h4"
                                                                className={classes.textPlain}>
                                                                Appointment images
                                                            </Typography>
                                                        </Box>
                                                        {notes.appointment.imageUrl.map((img) => (
                                                            <Box
                                                                display="flex"
                                                                justifyContent="center"
                                                                alignItems="center"
                                                                width="100px"
                                                                height="100px"
                                                                marginRight="10px"
                                                            >
                                                                <Image
                                                                    alt="images uploading while scheduling an appointment"
                                                                    imageStyle={{
                                                                        objectFit: "contain",
                                                                    }}
                                                                    errorIcon={<LogoSVG/>}
                                                                    src={img}
                                                                    style={{width: "100%"}}
                                                                />
                                                            </Box>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            </Grid>
                                                }
                                            </> :
                                            <>
                                                <Snackbar
                                                    open={openSnack}
                                                    autoHideDuration={4000}
                                                    onClose={handleCloseSnack}
                                                    message="Success!"
                                                    anchorOrigin={{
                                                        vertical: "top",
                                                        horizontal: "center"
                                                    }}
                                                    //@ts-ignore
                                                    ContentProps={{
                                                        className: classes.snackbarStyleViaContentProps
                                                    }}
                                                />
                                                <Grid item xs={12}>
                                                    <Box marginBottom="15px">
                                                        <Typography variant="h4" className={classes.textPlain}>
                                                            Who completed the follow up outreach?
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Box marginBottom="20px">
                                                        <TextField
                                                            multiline
                                                            fullWidth
                                                            value={follow?.completedBy || ""}
                                                            variant="outlined"
                                                            placeholder="Who completed the follow up outreach?"
                                                            disabled={user.role !== "ADMIN"}
                                                            onChange={((e) => setFollow({...follow, completedBy: e.target.value}))}
                                                        />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Box marginBottom="15px">
                                                        <Typography variant="h4" className={classes.textPlain}>
                                                            How is the pet doing after the visit?
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Box display="flex" flexDirection="column">
                                                    {
                                                        options.map(({label, value}, idx) => (
                                                            <FormControlLabel
                                                                key={idx}
                                                                control={
                                                                    <Checkbox
                                                                        key={idx}
                                                                        checked={value === follow?.animalFeeling || false}
                                                                        onChange={() => setFollow({...follow, animalFeeling: value})}
                                                                        name={value}
                                                                        disabled={user.role !== "ADMIN"}
                                                                    />
                                                                }
                                                                label={label}
                                                            />
                                                        ))
                                                    }
                                                </Box>
                                                {follow?.animalFeeling === "OTHER" && <Grid item xs={12}>
                                                    <Box marginBottom="20px">
                                                        <TextField
                                                            multiline
                                                            fullWidth
                                                            value={follow?.otherAnimalFeelingComment || ""}
                                                            variant="outlined"
                                                            placeholder={"Other"}
                                                            disabled={user.role !== "ADMIN"}
                                                            onChange={((e) => setFollow({...follow, otherAnimalFeelingComment: e.target.value}))}
                                                        />
                                                    </Box>
                                                </Grid>}
                                                <Grid item xs={12}>
                                                    <Box marginBottom="15px">
                                                        <Typography variant="h4" className={classes.textPlain}>
                                                            Did the pet go to an in person vet for this issue after
                                                            this appointment?
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Box display="flex" flexDirection="column">
                                                    <FormControlLabel
                                                        key={0}
                                                        control={
                                                            <Checkbox
                                                                key={0}
                                                                disabled={user.role !== "ADMIN"}
                                                                checked={follow?.appealAfterAppointment || false}
                                                                onChange={() => setFollow({...follow, appealAfterAppointment: true})}
                                                                name={"Yes"}
                                                            />
                                                        }
                                                        label={"Yes"}
                                                    />
                                                    <FormControlLabel
                                                        key={0}
                                                        control={
                                                            <Checkbox
                                                                key={1}
                                                                checked={typeof (follow?.appealAfterAppointment) === "boolean" ? !follow?.appealAfterAppointment : false}
                                                                onChange={() => setFollow({...follow, appealAfterAppointment: false})}
                                                                name={"No"}
                                                                disabled={user.role !== "ADMIN"}
                                                            />
                                                        }
                                                        label={"No"}
                                                    />
                                                </Box>
                                                <Grid item xs={12}>
                                                    <Box marginBottom="15px">
                                                        <Typography variant="h4" className={classes.textPlain}>
                                                            Any additional information provided by the pet parent?
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Box marginBottom="20px">
                                                        <TextField
                                                            multiline
                                                            fullWidth
                                                            value={follow?.petParentAdditionalInformation || ""}
                                                            variant="outlined"
                                                            placeholder={"Tell us more!"}
                                                            disabled={user.role !== "ADMIN"}
                                                            onChange={((e) => setFollow({...follow, petParentAdditionalInformation: e.target.value}))}
                                                        />
                                                    </Box>
                                                </Grid>
                                                {user.role === "ADMIN" &&
                                                    <Button
                                                        type="button"
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={handleFollowUpdate}
                                                        disabled={isDisable()}
                                                        className={classes.button}
                                                    >
                                                    Save
                                                    </Button>}
                                            </>}
                                </Grid>
                            </Grid>
                        </Grid>
                        :
                        <Typography color="textSecondary">No notes for this appointment yet</Typography>
                }
            </DialogContent>
            <DialogActions classes={{root: classes.actions}}>
                <Box display="flex" justifyContent="flex-start" width="100%">
                    <Button type="button" variant="contained" onClick={handleClose} className={classes.button}>
                        Close
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};




export default MedicalRecordsModal;
